import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { fetchRole, clearRole } from './roleSlice';

const initialState = {
  fieldOfficerInfo: null,
  status: 'idle',
  error: null,
  isLoggedIn: false,
};

// Login
export const login = createAsyncThunk(
  'fieldOfficer/login',
  async ({ base64PhoneAndOtp, description, otp }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        '/field-officer/verifyOTP',
        { description, otp },
        {
          headers: {
            Authorization: base64PhoneAndOtp,
          },
        }
      );
      
      dispatch(fetchRole());
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { msg: 'Login failed' });
    }
  }
);

export const fetchFieldOfficerInfo = createAsyncThunk(
  'fieldOfficer/fetchInfo',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/field-officer/info');
      return data.info;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const logout = createAsyncThunk('fieldOfficer/logout', async (_, { dispatch }) => {
  try {
    const { data } = await axiosInstance.post('/field-officer/logout');
    dispatch(clearRole());
    return data.msg;
  } catch (err) {
    dispatch(clearRole());
    return err.message;
  }
});

export const fieldOfficersSlice = createSlice({
  name: 'fieldOfficer',
  initialState,
  reducers: {
    setFieldOfficer: (state, action) => {
      state.fieldOfficerInfo = { ...action.payload };
    },
    resetFieldOfficerAuth: (state) => {
      state.isLoggedIn = false;
      state.fieldOfficerInfo = null;
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (action.payload.msg === 'OTP Verified') {
          state.error = null;
          state.isLoggedIn = true;
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.msg || 'Login Failed';
        state.isLoggedIn = false;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        if (action.payload.login_role === 'FIELD_OFFICER') {
          state.isLoggedIn = true;
          state.status = 'succeeded';
        }
      })
      .addCase(fetchFieldOfficerInfo.fulfilled, (state, action) => {
        state.fieldOfficerInfo = { ...action.payload };
      })
      .addCase(logout.fulfilled, (state) => {
        state.status = 'succeeded';
        state.fieldOfficerInfo = null;
        state.isLoggedIn = false;
      });
  },
});

export const fetchFieldOfficerInfoStatus = (state) => state.fieldOfficer.status;
export const loginStatus = (state) => state.fieldOfficer.status;
export const loginError = (state) => state.fieldOfficer.error;
export const getFieldOfficerInfoError = (state) => state.fieldOfficer.error;
export const { setFieldOfficer, resetFieldOfficerAuth } = fieldOfficersSlice.actions;

export default fieldOfficersSlice.reducer;